import { EXPERIENCE_TYPES } from "constants/experiences"
import { getSteps, SAVED_WIZARD_STEP_TO_TAB } from "../constants/stepConfig"

/**
 * The tab "Continue Creating" reopens a draft on: the one the guide last saved (the server's
 * wizard_step), when the listing's type has that tab. Undefined otherwise, so the wizard starts on
 * its first tab.
 */
export const getContinueStep = (trip) => {
  const listingType = trip?.experience_type === EXPERIENCE_TYPES.ticketed ? EXPERIENCE_TYPES.ticketed : EXPERIENCE_TYPES.private
  const stepId = SAVED_WIZARD_STEP_TO_TAB[trip?.wizard_step]
  return getSteps(listingType).includes(stepId) ? stepId : undefined
}
